export const weasleyFlowType = {
  FORCED_PASSWORDLESS_FLOW: 'forcedPaswordlessFlow',
  FORCED_WITH_PASSWORD_FLOW: 'forcedWithPasswordFlow',
  OPTIONAL_WITH_PASSWORD_FLOW: 'optionalWithPasswordFlow',
};
